import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {langRegister} from "../../services/langRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import {imagesRegister} from "../../services/imagesRegister";
import {quotesRegister} from "../../services/quotesRegister";
import Information from "../../components/information/component";

class SignupCrossroad extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            error: false,
            selected: "instant",
            disabled: ""
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);


        //GOOGLE ANALYTICS
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactGA.pageview('/signup/crossroad');
            ReactGA4.send({ hitType: "pageview", page: "/signup/crossroad" });
            ReactGA.event({category: 'User', action: 'Initiated Checkout', label: 'Crossroad'});
            ReactGA4.event({category: 'User', action: 'Initiated Checkout', label: 'Crossroad'});
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
            ReactPixel.track('InitiateCheckout');
        }

        this._updateSelected();
    }

    _updateSelected(){
        let cart = cartRegister.get();
        let disabled = salesChannelRegister.get('goal_off');

        if(disabled === "1"){
            this.setState({
                disabled: "1",
                isLoading: false,
                selected: "instant"
            })
        }else if(disabled === "2"){
            this.setState({
                disabled: "2",
                isLoading: false,
                selected: "continues"
            })
        }else{
            this.setState({
                isLoading: false,
                selected: cart.crossroad?cart.crossroad:"instant"
            });
        }

    }

    _next(value){
        let storage = cartRegister.getCheckout();
        if(storage.crossroad !== value){
            let industry = storage.industry;
            cartRegister.remove();
            quotesRegister.remove();
            imagesRegister.remove();
            cartRegister.setIndustry(industry);
            cartRegister.setCrossRoad(value);
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/image")
        }else{
            cartRegister.setCrossRoad(value);
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/image")
        }
    }

    _renderText(item) {
        return langRegister.get("signup-crossroad", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupOne view={"signup"} props={this.props}/>

                {
                    !this.state.isLoading && !this.state.error &&
                    <div className={Styles.container}>
                        <div className={Styles.title}>
                            <div>
                                {this._renderText("item_1")}
                            </div>
                        </div>
                        <div className={Styles.optionsContainer}>
                            <div className={Styles.optionsContainerItem}>
                                <div    className={Styles.optionsContainerItemInner}>
                                    <div onClick={() => {
                                        if(this.state.disabled !== "1"){
                                            this._next("continues")
                                        }
                                    }} className={
                                        cx(Styles.optionsContainerItemInnerLayer,
                                            {
                                                [Styles.optionsContainerItemInnerLayerSelected]: this.state.selected === "continues",
                                            })
                                    }>
                                        <div style={this.state.disabled === "1"?{color: "#bfbfbf"}:{}} className={Styles.optionsContainerItemInnerTitle}>
                                            {this._renderText("item_8")}<br/>{this._renderText("item_9")}
                                        </div>
                                        <div style={this.state.disabled === "1"?{color: "#bfbfbf"}:{}} className={Styles.optionsContainerItemInnerSubtitle}>
                                            {this._renderText("item_10")}
                                        </div>
                                    </div>
                                </div>
                                <div className={Styles.optionsContainerItemUnderTitle}>
                                    <div className={Styles.optionsContainerItemUnderTitleDollar}>
                                        $
                                    </div>
                                    <div className={Styles.optionsContainerItemUnderTitleText}>
                                        {this._renderText("item_11")}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.optionsContainerItem}>
                                <div className={Styles.optionsContainerItemInner}>
                                    <div onClick={() => {
                                        if(this.state.disabled !== "2"){
                                            this._next("instant")
                                        }
                                    }} className={
                                        cx(Styles.optionsContainerItemInnerLayer,
                                            {
                                                [Styles.optionsContainerItemInnerLayerSelected]: this.state.selected === "instant",
                                            })
                                    }>
                                        <div style={this.state.disabled === "2"?{color: "#bfbfbf"}:{}} className={Styles.optionsContainerItemInnerTitle}>
                                            {this._renderText("item_12")}<br/>{this._renderText("item_13")}
                                        </div>
                                        <div style={this.state.disabled === "2"?{color: "#bfbfbf"}:{}} className={Styles.optionsContainerItemInnerSubtitle}>
                                            {this._renderText("item_14")}
                                        </div>
                                    </div>
                                    <div style={this.state.disabled === "2"?{backgroundColor: "#bfbfbf"}:{}} className={Styles.optionsContainerItemInnerBadge}>
                                        {this._renderText("item_15")}
                                    </div>
                                </div>
                                <div className={Styles.optionsContainerItemUnderTitle}>
                                    <div className={Styles.optionsContainerItemUnderTitleDollar}>
                                        $$$
                                    </div>
                                    <div className={Styles.optionsContainerItemUnderTitleText}>
                                        {this._renderText("item_16")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
                <div id={"bottom"} style={{width:"100%"}}/>
            </div>
        );
    }
}

export default SignupCrossroad;


// WEBPACK FOOTER //
// ./src/pages/signup-crossroad/component.js